import {
  For,
  Match,
  Show,
  Switch,
  batch,
  createResource,
  createSignal,
  onMount,
} from "solid-js";
import { ModalV2 } from "../components/Modal";
import { SizeGuideV2 } from "../components/SizeGuide";
import { useHeroForm } from "../contexts/HeroFormContext";
import { validateOption } from "../js/formValidation";
import { getBlogPost } from "./StandardSizeForm";
import { DIYModal } from "./DIYModal";
import { OptionCard } from "./OptionCard";
import { StandardSizeContainer, StandardSizeSelectorWithGuide } from "../components/StandardSizeWithGuide"

const MadeToMeasureDiv = (props) => {
  const {
    color: { color },
    sizeSettings: {
      measurementOptionsV2,
      handlers: { handleMeasOptSelectionV2 },
    },
    sizeSettings,
    sizeOption: { sizeOption },
  } = useHeroForm();

  const [modalState, setModalState] = createSignal(false);
  const [modelContent, setModalContent] = createSignal({
    title: "How it works",
    content: "<div>How it works</div>",
  });

  const handleOptionSelection = (optionId) => {
    batch(() => {
      handleMeasOptSelectionV2(optionId);
      validateOption(sizeSettings, sizeOption());
    });
  };

  const handleModalOpenState = (state, content = null) => {
    batch(() => {
      const body = document.getElementsByTagName("body")[0];
      body.style.overflow = state ? "hidden" : "";
      if (content) {
        setModalContent(content);
      }
      setModalState(state);
    });
  };

  const measurementOptionsArr = () => {
    return Object.values(measurementOptionsV2.options)
      .filter((option) => option.id != "standard-size")
      .map((option) => ({
        id: option.id,
        label: option.label,
        subHeading: option.subHeading,
        icon: option.icon,
        hasDiscount: option.hasDiscount,
        discountText: option.discountText,
        howItWorks: option.howItWorks,
      }));
  };

  const getCurrentRelPath = () => {
    const url = new URL(window.location)
    return encodeURI(url.pathname + url.search)
  }

  return (
    <div class="flex flex-col divide-y-inner divide-frame">
      <For each={measurementOptionsArr()}>
        {(measurementOption, index) => {
          return (
            <SizeListOption
              color={color().selected}
              selected={measurementOptionsV2.selected}
              measurementOption={measurementOption}
              handleOptionSelection={handleOptionSelection}
              handleModalOpenState={handleModalOpenState}
              customerMetafield={customerMetafield}
            ></SizeListOption>
          );
        }}
      </For>

      <Show
        when={customerId === -1}
      >

        <div class="px-2 py-1 bg-canvas flex justify-between items-center" >
          <div class="font-bold text-sm lg:text-base text-ink w-max">Fetch your previous measurements</div>
          <a
            href={`/account/login?returnTo=` + getCurrentRelPath()}
            class="block font-regular text-sm   cursor-pointer  sm:landscape:text-right"
          >
            <div class="rounded-full py-1 px-2 text-canvas bg-ink">
              Login
            </div>

          </a>
        </div>



      </Show>

      <Show when={modalState()}>
        <ModalV2
          title={modelContent().title}
          modalState={modalState()}
          handleModalOpenState={handleModalOpenState}
        >
          <article class=" max-w-6xl mx-auto  h-full ">
            <div
              class="font-regular py-4 px-2 md:px-6 rte text-base h-full overflow-y-auto themed-scrollbar"
              innerHTML={modelContent().content}
            />
          </article>
        </ModalV2>
        <div
          class="mt-2 text-ink-link cursor-pointer underline hover:text-secondary-400"
          onClick={() => handleModalOpenState(false)}
        >
          {"sss"}
        </div>
      </Show>
    </div>
  );
};

const SizeListOption = (props) => {
  const {
    sizeSettings: { standardSizeData },
  } = useHeroForm();

  const retrievedMeasurements =
    props.customerMetafield && props.measurementOption.id === "made-to-measure";
  const isHowItWorksLinkAvl =
    props.measurementOption?.howItWorks != undefined &&
    props.measurementOption?.howItWorks?.blogLink != undefined &&
    props.measurementOption?.howItWorks?.blogLink?.trim().length > 0;

  const priceDiff = () =>
    Math.abs(
      (productInfo.variants?.custom?.[props.color]?.price ?? 0) -
      (productInfo.variants?.standard?.[props.color]?.price ?? 0)
    );

  const [howItWorksBlog] = isHowItWorksLinkAvl
    ? createResource(() =>
      getBlogPost(
        shopGraphQlUrl,
        heroSectionSettings["storefrontAccessToken"],
        props.measurementOption?.howItWorks?.blogLink
      )
    )
    : [() => null];

  return (
    <div
      class="flex flex-col group text-ink  transition-all p-2"
      classList={{
        "scale-[1.01]": props.selected === props.measurementOption.id,
        "cursor-pointer border-frame py-1":
          props.selected != props.measurementOption.id,
      }}
      onClick={() => props.handleOptionSelection(props.measurementOption.id)}
    >
      <div class="flex gap-2 items-center">
        <div
          class="size-2 border-frame  rounded-full border-inner flex items-center justify-center"
          classList={{
            "bg-primary-500": props.selected === props.measurementOption.id,
            "group-hover:bg-canvas-lighter":
              props.selected != props.measurementOption.id,
          }}
        >
          <svg
            width="12px"
            h="12px"
            viewBox="0 -960 960 960"
            classList={{
              "text-canvas": props.selected === props.measurementOption.id,
              hidden: props.selected != props.measurementOption.id,
            }}
          >
            <path
              fill="currentColor"
              d="M395-245 185-456l90-90 120 120 291-290 90 90-381 381Z"
            />
          </svg>
        </div>
        <div className="flex flex-wrap gap-x-1 items-center grow">
          <div class="font-bold  text-sm lg:text-base">
            {props.measurementOption.label}
          </div>
          <Show
            when={
              props.measurementOption.hasDiscount &&
              props.customerMetafield === null &&
              priceDiff() != 0 &&
              props.measurementOption.discountText
            }
          >
            <div class="text-2xs font-mono rounded-full py-0.5 px-2 w-fit bg-primary-500 text-canvas">
              {props.measurementOption.discountText.replace(
                "DISCOUNT_PRICE",
                priceDiff()
              )}
            </div>
          </Show>
        </div>
        <div class="w-4 h-4" innerHTML={props.measurementOption.icon}></div>
      </div>
      <div
        class="mx-4 text-xs lg:text-sm flex flex-col items-start"
        classList={{
          block: props.selected === props.measurementOption.id,
          hidden: props.selected != props.measurementOption.id,
        }}
      >
        <div innerHTML={props.measurementOption.subHeading} />
        <Show when={props.measurementOption.id == "measure-it-yourself"}>
          <DIYModal />
        </Show>
      </div>

      <Show
        when={props.measurementOption?.howItWorks?.blogLink?.trim().length > 0}
      >
        <div
          class="w-full pl-4  pr-2 text-xs text-ink-link "
          classList={{
            "block ": props.selected === props.measurementOption.id,
            "block text-left sm:portrait:block xl:block":
              props.selected != props.measurementOption.id,
          }}
        >
          <span
            class="max-w-max hover:underline cursor-pointer"
            onClick={() =>
              props.handleModalOpenState(true, {
                title:
                  '<span class="font-regular text-sm">How it works:</span><br/>' +
                  props.measurementOption.label,
                content: howItWorksBlog().replaceAll("REFNOUN", REFERENCE_NOUN),
              })
            }
          >
            How it works &gt;
          </span>
        </div>
      </Show>
    </div>
  );
};

const FitSelector = (props) => {
  const options = () => props.customization.options;
  const selectedOption = () => options()[props.customization.selected];

  const {
    sizeSettings: {
      standardSizeData
    },
    navBarData: {
      handlers: { handleNavBarChange, handleNavBarVisiblity },
    },
  } = props?.context();

  const handleSelection = () => {
    batch(() => {
      handleNavBarChange(handleize(props.customization.label));
      handleNavBarVisiblity(true);
    });
  };

  return (
    <div class={`w-full flex-col cursor-pointer flex gap-1 ${props?.isModal ? '' : 'pb-2'}`}
      classList={{
        "px-2": !props.isOnlyStandardSize
      }}
    >
      <div class="flex-auto font-medium text-sm flex justify-between">
        <div class="flex gap-0.5 items-baseline">
          <h3>{props.customization.label}:</h3>
          <span class="font-regular text-xs">{selectedOption().label}</span>
        </div>
        <Show when={props.isModal != true}>
          <SizeGuideV2
            data={standardSizeData().sizeGuide}
            context={props?.context}
          />
        </Show>
      </div>
      <div class="flex-auto flex gap-2">
        <For each={Object.values(options())}>
          {(option, index) => (
            <Show when={option.isEnabled == undefined || option.isEnabled}>
              <OptionCard
                selectedValue={props.customization.selected}
                option={option}
                handleSelection={props.handleSelection}
                className="text-xs"
                hideIcon={true}
              />
            </Show>
          )}
        </For>
      </div>
    </div>
  );
};

export const SizeButtonWithTabs = (props) => {
  const {
    color: {
      color
    },
    sizeSettings: {
      measurementOptionsV2,
      madeToMeasureData,
      errorMessage,
      standardSizeData,
      handlers: { handleMeasOptSelectionV2 },
    },
    fit: {
      fit,
      handlers: { handleFitSelection },
    },
    sizeSettings,
    sizeOption: { sizeOption },
    getters: { getExperimentFlags },
    heroSectionSettings
  } = props?.context();

  const isSelectedOptionEmpty = () =>
    measurementOptionsV2.selected?.trim().length == 0;

  const measurementOptionEnum = Object.freeze({
    STANDARD_SIZE: "standard-size",
    CUSTOM_FIT: "custom-fit",
  });

  const handleOptionSelection = (optionId) => {
    batch(() => {
      handleMeasOptSelectionV2(optionId);
      validateOption(sizeSettings, sizeOption());
    });
  };

  onMount(() => {
    if (isOnlyMTM) {
      handleOptionSelection(Object.keys(measurementOptionsV2.options)?.[0]);
    } else {
      handleOptionSelection(measurementOptionEnum.STANDARD_SIZE);
    }
  });


  const getCurrentRelPath = () => {
    const url = new URL(window.location);
    return encodeURI(url.pathname + url.search);
  };
  const isOnlyStandardSize = Object.keys(measurementOptionsV2.options).filter(k => k != 'standard-size').length == 0;
  const isOnlyMTM = Object.keys(measurementOptionsV2.options).filter(k => k == 'standard-size').length == 0 && Object.keys(measurementOptionsV2.options).length > 0;

  const tabOptions = {
    [measurementOptionEnum.STANDARD_SIZE]: { title: " Standard Sizes" }
  };

  if (props?.isModal != true && !isOnlyStandardSize && !isOnlyMTM) {
    tabOptions[[measurementOptionEnum.CUSTOM_FIT]] = { title: "Custom Sizes" }
  }

  return (
    <div class="flex flex-col items-start px-2 sm:px-6 border-t-outer border-frame">
      <div
        class="flex gap-2 items-baseline w-full max-w-lg text-sm sm:text-base font-medium sm:landscape:px-0 justify-between"
        classList={{
          "my-1": props.isModal != true,
          "mb-0.5 sm:my-1": props.isModal == true
        }}
      >
        <span
          class="text-sm md:text-base font-bold"
          classList={{
            "hidden": heroSectionSettings.isNewVersion
          }}
        >Size</span>
        <Show when={props.isModal == true}>
          <SizeGuideV2
            data={standardSizeData().sizeGuide}
            context={props?.context}
          />
        </Show>
      </div>
      <div class="flex max-w-lg w-full justify-stretch">
        <For each={Object.keys(tabOptions)}>
          {(tabId) => {
            const isTabActive = () => {
              if (tabId === "standard-size") {
                return (
                  measurementOptionsV2.selected ===
                  measurementOptionEnum.STANDARD_SIZE
                );
              } else {
                return (
                  measurementOptionsV2.selected !=
                  measurementOptionEnum.STANDARD_SIZE
                );
              }
            };
            const handleTabClick = (tabId) => {
              if (tabId === measurementOptionEnum.STANDARD_SIZE) {
                handleMeasOptSelectionV2(measurementOptionEnum.STANDARD_SIZE);
              } else {
                handleMeasOptSelectionV2(Object.keys(measurementOptionsV2.options).find(s => s == 'measure-it-yourself') ?? Object.keys(measurementOptionsV2.options).find(s => s == 'made-to-measure') ?? null);
              }
            };
            return (
              <Show when={props?.isModal != true && !isOnlyStandardSize && !isOnlyMTM}>
                <div
                  classList={{
                    "font-bold border-frame bg-canvas-light border-b-transparent translate-y-[2px] boxy-shadow-sm":
                      isTabActive(),
                    "font-medium border-x-transparent border-t-transparent border-b-frame ":
                      !isTabActive(),
                  }}
                  class={`p-2 flex-auto text-sm  text-center cursor-pointer border-inner transition-transform duration-100 flex-col flex`}
                  onClick={[handleTabClick, tabId]}
                >
                  <span>{tabOptions[tabId].title}</span>
                  {/* <span class="text-xs text-secondary-500 font-mono">+400</span> */}
                </div>
              </Show>
            );
          }}
        </For>
      </div>

      <div
        class={`${props?.isModal ? '' : 'catalog-border-color'} max-w-lg w-full  z-10 relative bg-secondary-50 border-x-inner border-frame boxy-shadow-sm`}
        classList={{ "border-t-2": (isOnlyStandardSize || isOnlyMTM) }}
      >
        <Switch fallback="">
          <Match
            when={
              measurementOptionsV2.selected !=
              measurementOptionEnum.STANDARD_SIZE
            }
          >
            <MadeToMeasureDiv
              madeToMeasureData={madeToMeasureData}
              howItWorksBlog={howItWorksBlog()}
            />
          </Match>
          <Match
            when={
              measurementOptionsV2.selected ==
              measurementOptionEnum.STANDARD_SIZE
            }
          >

            <div
              classList={{
                "p-2": !heroSectionSettings.isNewVersion
              }}
            >
              <Show
                when={heroSectionSettings.isNewVersion}
                fallback={(
                  <StandardSizeSelectorWithGuide
                    data={standardSizeData().sizeGuide}
                    context={props?.context}
                  />
                )}
              >
                <StandardSizeContainer
                  data={standardSizeData().sizeGuide}
                  context={props?.context}
                />
              </Show>
            </div>
          </Match>
        </Switch>
      </div>

      {/* <Show
        when={errorMessage() != undefined && errorMessage()?.trim().length > 0}
      >
        <div class="text-error-100 bg-error-600 w-full text-left py-1 px-2 flex justify-between items-center mt-1 rounded-lg border-dashed border-error-800 border-outer">
          <div innerHTML={errorMessage()} />
        </div>
      </Show> */}
    </div>
  );
};
